export const moduleName = 'template'
